/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplatePeoplePickerContainer as TemplatePeoplePicker } from './TemplatePeoplePicker.container';
